import React from "react";

// HOOKS
import { useSearchParams } from "react-router-dom";

// Modules
import { Navigate } from "react-router-dom";

const LegacyReport = () => {
    console.log("LEGACY detected");
    const [searchParams] = useSearchParams();
    const reportID = searchParams.get("token") ?? "";
    return <Navigate to={`/report/${reportID.split("-")[0] ?? ""}`} />;
};

export default LegacyReport;
